import React from 'react';
import { useStyles } from './BusinessProfileActivity.styles';

interface Props {
  metric: number;
  text: string;
  isMoney?: boolean;
}
const ActivityTile = ({ metric, text, isMoney }: Props) => {
  const classes = useStyles();
  return (
    <div>
      {!!metric && (
        <p style={{ margin: '0px' }}>
          <span className={classes.value} suppressHydrationWarning>
            {isMoney ? '$' : ''}
            {metric?.toLocaleString()}
          </span>
          <span className={classes.field}>{text}</span>
        </p>
      )}
    </div>
  );
};

export default ActivityTile;
